/**
 * Generated runtime TestId mirror for frontend/src/features/notifications/NotificationBell.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const NotificationBellTestIds = {
  markAllRead: "mark-all-read",
  notificationBell: "notification-bell",
  unreadBadge: "unread-badge",
  viewAllNotifications: "view-all-notifications",
  notificationItem: (notification_id: string) => `notification-item-${notification_id}`,
  notificationItemPrefix: () => "notification-item-" as TestIdPrefix,
  notificationItemTitle: (notification_id: string) => `notification-item-title-${notification_id}`,
  notificationItemTitlePrefix: () => "notification-item-title-" as TestIdPrefix
} as const;
